<template>
  <div class="right-content clearfix">
    <view-container :loading="loading" :empty="empty || !noticeList.length" :error="error" @retry="loadData">
      <ul>
        <li v-for="(item) in noticeList" :key="item.title">
          <span :class="{'tag1': item.ancestors[0].name.includes('自营'), 'tag2': item.ancestors[0].name.includes('唯品国际'), 'tag3': !item.ancestors[0].name.includes('自营') && !item.ancestors[0].name.includes('唯品国际')}">{{item.ancestors[0].name}}</span>
          <p>
            <template v-if="page === 'Notice' || item.isNotice">
              <router-link :to="{ name: 'NoticeDetail', query: {ruleId: item.ruleId}}">
                <span class="high-light" v-html="item.title"></span>
              </router-link>
            </template>
            <template v-else>
              <router-link :to="{ name: 'Detail', query: {ruleId: item.ruleId}}">
                <span class="high-light" v-html="item.title"></span>
              </router-link>
            </template>

            <span class="content hide">为更好地帮助唯品会开放平台商家提升整体服务品质和经营能力，不断提高消费者购物体验，提升唯品会开放平台的整体商品质量和服务水平，与商…</span>
          </p>
        </li>
      </ul>
      <pagination v-model:pageModal="pageModal" @query="loadDataOfSearch(categoryId)"/>
    </view-container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import viewContainer from '@/components/viewContainer'
import pagination from '@/components/pagination.vue'
export default {
  name: '',
  data () {
    return {
      categoryId: [0],
      pageModal: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      list: [],
      loading: false,
      empty: false,
      error: false
    }
  },
  computed: {
    ...mapState('rule', ['getChildrenFn', 'noticeList', 'page', 'ruleCounts'])
  },
  beforeCreate () {
    this.categoryId = decodeURIComponent(this.$route.query.categoryId)
  },
  async mounted () {
    // this.getChildrenFn.then(() => {
    //   if (this.page === 'Notice') {
    //     return this.loadDataOfNotice()
    //   }
    //   this.loadData()
    // })
  },
  methods: {
    loadDataOfSearch (categoryId = []) {
      const {
        pageNo,
        pageSize
      } = this.pageModal
      const categoryIds = categoryId
      this.loading = true
      this.empty = false
      this.error = false
      this.pageModal.total = 0
      this.search({
        pageNo,
        pageSize,
        categoryIds: categoryIds.length === 1 && categoryIds[0] === 0 ? [] : categoryIds
      }).then((resp) => {
        // console.log(11133, resp, this.categoryId)
        let total = 0
        resp.total.forEach((item) => {
          if (this.categoryId.includes(item.category.categoryId)) {
            return total += item.count
          }
          return this.categoryId.includes(item.category.categoryId)
        })
        if (!total) {
          this.empty = true
        } else {
          this.pageModal.total = total
        }
      }).catch(() => {
        this.error = true
      }).finally(() => {
        this.loading = false
      })
    },
    loadData (categoryId) {
      this.categoryId = !categoryId || !categoryId.length || (categoryId.length === 1 && categoryId[0] === 0) ? [0] : categoryId
      if (this.page === 'Search') {
        const {
          phrase
        } = this.$route.query
        this.updatePhrase(phrase)
        if (this.pageModal.pageNo === 1) {
          return this.loadDataOfSearch(this.categoryId)
        }
        this.pageModal.pageNo = 1
        this.loadDataOfSearch(this.categoryId)
      }
    },
    ...mapActions('rule', ['getRuleOverview', 'getNoticeOverview', 'search']),
    ...mapMutations('rule', ['updatePhrase'])
  },
  components: {
    viewContainer,
    pagination
  }
}
</script>

<style lang="scss" scoped>
ul {
  float: left;
  width: 100%;
  li {
    float: left;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    > span:first-child {
      float: left;
      font-size: 12px;
      color: #627DB6;
      background: rgba($color: #627DB6, $alpha: 0.1);
      border-radius: 2px;
      padding: 2px;
      line-height: 14px;
      min-width: 48px;
      text-align: center;
    }
    .tag1 {
      background: #FEEFF3!important;
      color: #F03867!important;
    }
    .tag2 {
      background: rgba($color: #6C5EAB, $alpha: 0.12) !important;
      color: #6C5EAB!important;
    }
    .tag3  {
      background: rgba($color: #EDF3FF, $alpha: 1.0) !important;
      color: #627DB6 !important;
    }
    .high-light {
      :deep(em) {
        color: #F10180;
        font-style: normal;
      }
    }
    p  {
      padding-left: 10px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 130px;
      span.content {
        font-size: 12px;
        color: #999;
        font-weight: 400;
        display: block;
        margin-top: 5px;
      }
    }
    > span:nth-child(3) {
      position: absolute;
      top: 0;
      right: 30px;
      font-size: 14px;
      color: #999;
      font-weight: 400;
    }
  }
}
.empty-container {
  background: url(../../assets/img/pic_tongyongweikong@2x.png) top center no-repeat;
  min-height: 200px;
  padding-top: 190px;
  text-align: center;
}
.warning-container {
  background: url(../../assets/img/pic_wangluoweilianjie@2x.png) top center no-repeat;
  min-height: 200px;
  padding-top: 190px;
  text-align: center;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  button {
    font-size: 16px;
    color: #F10180;
    text-align: justify;
    font-weight: 400;
    border: 1px solid #F10180;
    border-radius: 3px;
    background: #fff;
    width: 185px;
    height: 44px;
    text-align: center;
    margin-top: 20px;
    outline: none;
  }
}
</style>
